import React from 'react';

import { createErrorFunction } from '../utils/TypescriptHelpers';
import { ErrorList } from './types/ErrorList';

const defaultErrorList: ErrorList = {
  addError:
    createErrorFunction('Function of default ErrorList context called: addError'),
  removeError:
    createErrorFunction('Function of default ErrorList context called: removeError'),
  clearErrors:
    createErrorFunction('Function of default ErrorList context called: clearErrors'),
  errors: [],
};

export const ErrorListContext = React.createContext<ErrorList>(defaultErrorList);
